import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { WHATSAPP_CONFIG } from '../lib/whatsapp';

/**
 * Floating WhatsApp button, Fresh Leaf style: a leaf-green pill with the ink
 * WhatsApp mark. Slides in after two seconds; on product pages on phones it
 * sits above the sticky "Add to bag" bar.
 */
export default function WhatsAppButton() {
    const location = useLocation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 2000);
        return () => clearTimeout(timer);
    }, []);

    const path = location.pathname;
    const onProduct = path.startsWith('/product/');
    const context = onProduct ? 'this product' : path.startsWith('/collection') ? 'this collection' : undefined;
    const whatsappUrl = `https://wa.me/${WHATSAPP_CONFIG.phoneNumber}?text=${encodeURIComponent(WHATSAPP_CONFIG.googleQuoteMessage(context))}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ask us on WhatsApp"
            className={`fixed right-4 z-40 flex items-center gap-2 rounded-full transition-all duration-700 ease-out hover:bg-[#9BD150] sm:right-6 ${onProduct ? 'bottom-[88px] lg:bottom-6' : 'bottom-4 sm:bottom-6'} ${isVisible ? 'translate-x-0 opacity-100' : 'pointer-events-none translate-x-[140%] opacity-0'}`}
            style={{
                height: 56,
                padding: '0 6px',
                background: '#8BC540',
                color: '#0F2616',
                textDecoration: 'none',
                boxShadow: '0 16px 40px rgba(15,38,22,0.22)',
                border: '1px solid rgba(255,255,255,0.6)',
            }}
        >
            <span style={{ width: 44, height: 44, borderRadius: '50%', background: '#0F2616', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .018 5.396.015 12.03c0 2.12.559 4.189 1.619 6.007L0 24l6.135-1.61a11.81 11.81 0 005.91 1.57h.005c6.637 0 12.032-5.396 12.035-12.032a11.762 11.762 0 00-3.48-8.504z" />
                </svg>
            </span>
            <span className="hidden sm:inline" style={{ paddingRight: 16, fontSize: 14, fontWeight: 700, whiteSpace: 'nowrap' }}>
                Ask us on WhatsApp
            </span>
        </a>
    );
}
